import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {Requester} from './requester.model';

@Injectable({providedIn: 'root'})
export class RequesterService extends DaoGeneric<Requester> {
  private _api = `${environment.baseUrl}/demat/requester/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(urlApp: string | undefined): string {
    return this._api;
  }
}
